import { api } from "../api";
import { VehicleParameter } from "../../../types/types";

const findVehicleParametersByVehicleAndCustomer = async (
    token: string,
    vehicleId: number,
    customerId: number,
) => {
    const response = await api.get<VehicleParameter>(
        `/vehicle-parameters/vehicle/${vehicleId}/customer/${customerId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    return response;
};

export default findVehicleParametersByVehicleAndCustomer;
